import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { Col as FlexboxCol } from 'react-styled-flexboxgrid';
var propTypes = {
  /**
   * Children for the Col component
   */
  children: PropTypes.node.isRequired,

  /**
   * When provided, will set sizes for the specific Col component for each viewport, and override the Grid level settings
   */
  colSizes: PropTypes.object
};
var defaultProps = {
  colSizes: {}
};

var Col = function Col(props) {
  return /*#__PURE__*/React.createElement(FlexboxCol, _extends({}, props.colSizes, props), props.children);
};

Col.propTypes = propTypes;
Col.defaultProps = defaultProps;
export default Col;